import { extend, Node } from '@react-three/fiber'
import { Environment, useTexture, shaderMaterial } from '@react-three/drei'
import { useEffect, useState, useRef } from 'react'
import { BackSide, ShaderMaterial } from 'three'
import { animated, useSpring, config } from '@react-spring/three'
import { useControls } from 'leva'

const vert = `
  varying vec2 vUv;

  void main() {
      vUv = uv;

      gl_Position = projectionMatrix * 
                    modelViewMatrix * 
                    vec4(position,1.0);
  }
`

const frag = `
  uniform sampler2D uTextureCurrent;
  uniform sampler2D uTextureNext;
  uniform float uTime;

  varying vec2 vUv;

  void main() {
      float factor = uTime;
      vec4 colorCurrent = texture2D(uTextureCurrent, vUv);
      vec4 colorNext = texture2D(uTextureNext, vUv);
      gl_FragColor = mix(colorCurrent, colorNext, factor);
  }
`

const EnvShaderMaterial = shaderMaterial(
  {
    uTextureCurrent: null,
    uTextureNext: null,
    uTime: [0, 1],
  },
  vert,
  frag
)

extend({ EnvShaderMaterial })

declare global {
  namespace JSX {
    interface IntrinsicElements {
      envShaderMaterial: Node<ShaderMaterial, typeof shaderMaterial>
    }
  }
}

function usePrevious(value: any) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value //assign the value of ref to the argument
  }, [value]) //this code will run when the value of 'value' changes
  return ref.current //in the end, return the current ref value.
}

export const AnimatedEnvironment = ({ id }: { id: number }) => {
  const { backgroundColor } = useControls('Seasons', {
    backgroundColor: { r: 92, g: 73, b: 64 },
  })
  const prevId = usePrevious(id) || 0
  const maps = useTexture([
    require('./potsdamer_platz_1k.jpg'),
    require('./forest_slope_1k.jpg'),
    require('./dikhololo_night_1k.jpg'),
    require('./kiara_1_dawn_4k.jpg'),
  ])

  const [colors, setColors] = useState([
    [154, 141, 135], //[92, 73, 64],
    [255, 255, 255],
    [7, 6, 6],
    [111, 90, 99],
  ])

  console.log('currentId', prevId, 'nextId', id)

  const FinalMaterial = animated(({ time }: { time: any }) => {
    // TODO Console log the props, is the animation managed by React Spring?
    return (
      <envShaderMaterial
        //@ts-ignore
        uTextureCurrent={maps[prevId]}
        uTextureNext={maps[id]}
        uTime={time}
        attach='material'
        side={BackSide}
      />
    )
  })

  const FinalBackgroundColor = animated(({ color }: { color: any }) => {
    return <color attach='background' args={color} />
  })

  const transition = useSpring({
    config: config.molasses,
    from: { time: 0 },
    to: { time: 1 },
    reset: true,
  })

  const colorTransition = useSpring({
    color: colors[id],
    config: config.molasses,
  })

  useEffect(() => {
    const c = colors
    c[id] = Object.values(backgroundColor).map((v) => v)
    setColors(c)
  }, [backgroundColor])

  return (
    <>
      <Environment frames={Infinity} resolution={256}>
        <mesh scale={99}>
          <sphereGeometry args={[1, 64, 64]} />
          {/* @ts-ignore */}
          <FinalMaterial time={transition.time.to((v) => v)} />
        </mesh>
      </Environment>
      {/* @ts-ignore */}
      {/* <FinalBackgroundColor
        color={colorTransition.color.to((r, g, b) => [
          r / 255,
          g / 255,
          b / 255,
        ])}
      /> */}
    </>
  )
}
